module.exports = __webpack_public_path__ + "static/img/4272_phase_function_Paper_Points.cb9dc0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4272_phase_function_Paper_Points.png
// module id = PsNJ
// module chunks = 0